// src/pages/nascar/XfGfs.jsx
import React from "react";
import NascarGfsPage from "../../components/NascarGfsPage";

export default function XfGfs() {
  return (
    <NascarGfsPage
      title="Xfinity GFS Model"
      seriesKey="xfinity"
    />
  );
}
